import axios from 'axios'
import Userauth from '../src/auth/js/index'
import Vue from 'vue'
import Toasted from 'vue-toasted'

Vue.use(Toasted, {
  position: 'top-center',
  duration: 5000,
  keepOnHover: true
})

let baseUrl = process.env.VUE_APP_BASEURL
// let baseUrl = `http://frausprotect.makeapk.com:7878/api`
var client = axios.create({
  baseURL: baseUrl,
  timeout: (1000 * 5 * 60)
});
let networkFail = false;
let currentToast = null;
let checkInterval = null;

export default {
  async execute(method, uri, data){
    try {
      // If network has failed and this is not /alive endpoint, block the call
      if (networkFail && !uri.includes('/alive')) {
        console.log('Network is down, blocking API call')
        return { error: 'Network is down' }
      }
      
      let req = await client({
        method,
        url : uri,
        withCredentials : true,
        data : data
      })
      
      // If /alive succeeds and network was marked as failed, restore everything
      if (uri.includes('/alive') && networkFail) {
        console.log('Network connection restored via /alive')
        networkFail = false;
        
        // Dismiss the persistent toast
        if (currentToast) {
          currentToast.goAway(0);
          currentToast = null;
        }
        
        // Clear the check interval
        if (checkInterval) {
          clearInterval(checkInterval);
          checkInterval = null;
        }
        
        // Show success notification
        Vue.toasted.success('Connection restored!', {
          duration: 2000,
          className: 'network-success-toast'
        })
      }
      
      return req.data
    } catch (err) {
      console.log('Error in getting Server uri')
      console.log(err)
      
      // Check for network error (when err.response is undefined)
      if(err.message === 'Network Error' || !err.response){
        console.log("Network error detected for URI:", uri)
        
        // If network was working and now failed, show toast and start checking
        if (!networkFail) {
          networkFail = true;
          console.log('Network failed, setting networkFail to true')
          
          // Show persistent toast
          if (!currentToast) {
            currentToast = Vue.toasted.error('Network connection lost. Checking for connection...', {
              duration: 0, // Persistent toast
              className: 'network-error-toast'
            })
          }
          
          // Start checking /alive every 10 seconds
          if (!checkInterval) {
            checkInterval = setInterval(() => {
              console.log('Checking network with /alive...')
              this.execute('GET', '/alive', null)
            }, 5000)
          }
        }
      }
      
      // Only check response status if response exists
      if(err.response && err.response.status == 401){
        Userauth.ForcefullyLogout()
      }
      
      return err
    }
  }
}